<template>
  <div class="page-table scrollable only-y">
    <filter-settings
      ref="filterSettings"
      :modalVisible="filterVisible"
      @applyFilter="applyFilter"
      @closeModal="closeFilterModal"
    />
    <!-- TABLE -->
    <div class="no-table-box page-header">
      <el-row class="hidden-sm-and-up pb-15">
        <h1>
          <v-svg class="voxo-orange" sprite="fax" />
          Faxes
        </h1>
      </el-row>
      <el-row class="hidden-xs-only pb-15">
        <el-col :span="12">
          <h1>
            <v-svg class="voxo-orange" sprite="fax" />
            Faxes
          </h1>
        </el-col>
        <el-col class="text-right" :span="12">
          <el-tag>
            <i class="el-icon-info" style="margin-right: 4px" />
            Total: {{ total | number }}
          </el-tag>
        </el-col>
      </el-row>
      <div class="flex">
        <div class="box mv-10">
          <el-button @click="filterVisible = true">
            Filter
          </el-button>
          <el-button
            @click="resetTable"
            v-if="advancedActive"
            style="background-color: #f25a6b; color: #fff;"
          >
            Reset
          </el-button>
        </div>
        <div class="box right">
          <div v-if="tableData.length" class="box right">
            <el-pagination
              small
              background
              layout="prev, pager, next"
              @current-change="pageSet"
              @next-click="pageNext"
              @prev-click="pagePrevious"
              :current-page="page"
              :page-size="limit"
              :pager-count="5"
              :total="total"
            />
          </div>
        </div>
      </div>
      <div class="vxe-table-height card-base card-shadow--medium">
        <vxe-grid
          round
          border="inner"
          ref="xGrid"
          height="100%"
          auto-resize
          empty-text="No Data"
          show-overflow="tooltip"
          highlight-hover-row
          @cell-mouseenter="rowHover"
          @cell-mouseleave="rowLeave"
          :data="tableData"
          :scroll-y="{enabled: true, gt: 50, oSize: 0}"
          :loading="tableLoading"
          :columns="tableColumns"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import feathersClient, {apiV2Host} from "../../../feathers/feathers-client";
import debounce from "lodash/debounce";
import filterSettings from "./components/filter-settings";
import moment from "moment";
import {phoneNumberFormatter} from "@/globals/globals";

export default {
  name: "FaxesTable",

  components: {
    filterSettings
  },

  data() {
    return {
      createVisible: false,
      filterVisible: false,
      search: '',
      limit: 300,
      page: 1,
      pages: 1,
      total: 0,
      tableData: [],
      // needsBackendFilter: true,
      // initialQueryDone: false,
      visibleActionsId: "",
      filterParams: null,
      advancedActive: false,
      tableLoading: false,
      tableColumns: [
        {
          field: 'sprite',
          title: '',
          width: 50,
          slots: {
            default: ({row}) => {
              return [
                <div class="voxo-square-icon voxo-bg-btn">
                  <v-svg class="voxo-orange" sprite="fax"/>
                </div>
              ]
            }
          }
        },
        {
          field: 'date',
          title: 'Date',
          showOverflow: false,
          minWidth: 150,
          slots: {
            default: ({row}) => {
              return [
                <span>{this.timeFormatter(row.date)}</span>
              ]
            }
          }
        },
        {
          field: 'sourceNum',
          title: 'From Number',
          minWidth: 150,
          showOverflow: false,
          slots: {
            default: ({row}) => {
              return [
                <span>{this.numberFormatter(row.sourceNum)}</span>
              ]
            }
          }
        },
        {
          field: 'sourceName',
          title: 'From Name',
          minWidth: 150,
          showOverflow: true
        },
        {
          field: 'destNum',
          title: 'To Number',
          minWidth: 150,
          showOverflow: false,
          slots: {
            default: ({row}) => {
              return [
                <span>{this.numberFormatter(row.destNum)}</span>
              ]
            }
          }
        },
        {
          field: 'direction',
          title: 'Direction',
          minWidth: 75,
          showOverflow: false
        },
        {
          field: 'status',
          title: 'Status',
          minWidth: 100,
          showOverflow: false
        },
        {
          field: 'error',
          title: 'Error',
          minWidth: 200,
          showOverflow: true
        },
        {
          field: 'actions',
          title: '',
          minWidth: '150',
          showOverflow: false,
          slots: {
            default: ({row}) => {
              return [
                <div v-show={row.id === this.visibleActionsId}>
                  <el-tooltip placement="top" content="Download">
                    <el-button
                      id={'edit-' + row.id}
                      icon="el-icon-download"
                      onClick={() => this.downloadFax(row.id)}
                      class="table-action-button icon-blue"
                    />
                  </el-tooltip>
                  <el-tooltip placement="top" content="Force resend">
                    <el-button
                      id={'delete-' + row.id}
                      icon="el-icon-refresh"
                      onClick={() => this.forceResendFax(row.id)}
                      class="table-action-button icon-orange"
                    />
                  </el-tooltip>
                </div>
              ]
            }
          }
        }
      ]
    };
  },

  computed: {

    selectedTenant() {
      return this.$store.state.selectedTenant;
    },

    user() {
      return this.$store.state.auth.user;
    },

    userOffsetMinutes() {
      return this.$store.state.userTimeOffset;
    }
  },

  watch: {
    page: debounce(function() {
      this.getFaxes();
    }, 500),

    user() {
      this.getFaxes()
    },

    selectedTenant() {
      //just trigger the page watcher if we aren't already on page 1
      this.page === 1 ? this.getFaxes() : this.page = 1;
    }
  },

  methods: {

    //General Form and Table Operations
    rowHover(data){
      this.visibleActionsId = data.row.id;
    },

    rowLeave(){
      this.visibleActionsId = "";
    },

    getFaxes() {

      this.tableData = [];
      if (this.user) {
        this.tableLoading = true;
        let query = {
          tenantId: this.selectedTenant.id,
          $limit: this.limit,
          $skip: this.page > 1 ? this.limit * (this.page - 1) : 0,
          $sort: { date: -1 }
        };

        if (this.filterParams) {
          const { dateFilter, numberFilter } = this.filterParams;
          query = {
            ...query,
            date: dateFilter,
            $or: [
              { sourceNum: { $like: `%${numberFilter}%` } },
              { destNum: { $like: `%${numberFilter}%` } }
            ]
          };
        }

        feathersClient.service('faxes').find({
          query
        }).then(response => {
          this.limit = response.limit;
          this.pages = Math.ceil(response.total / response.limit);
          this.total = response.total;
          this.page = this.page > this.pages ? 1 : this.page;
          this.tableData = [...response.data];
          this.tableLoading = false;
        });
      }
    },

    pageNext() {
      if (this.page < this.pages) {
        this.page += 1;
      }
    },

    pagePrevious() {
      if (this.page > 1) {
        this.page -= 1;
      }
    },

    pageSet(page) {
      this.page = page;
    },

    closeFilterModal() {
      this.filterVisible = false;
    },

    applyFilter(params) {
      this.filterParams = params;
      const currentPage = this.page;
      //just trigger the page watcher if we aren't already on page 1
      this.page === 1 ? this.getFaxes() : this.page = 1;
      this.filterVisible = false;
      this.advancedActive = true;
    },

    resetTable() {
      this.advancedActive = false;
      this.filterParams = null;
      this.$refs.filterSettings.resetFilters();
      //just trigger the page watcher if we aren't already on page 1
      this.page === 1 ? this.getFaxes() : this.page = 1;
    },

    numberFormatter(val){
      return phoneNumberFormatter(val);
    },

    timeFormatter(value) {
      const offsetMinutes = Math.abs(this.userOffsetMinutes);

      return this.userOffsetMinutes < 0
        ? moment(value)
            .subtract(offsetMinutes, "minutes")
            .format("M/DD/YY h:mm A")
        : moment(value)
            .add(offsetMinutes, "minutes")
            .format("M/DD/YY h:mm A");
    },

    async downloadFax(id) {
      this.tableLoading = true;

      try {
        const downloadReq = await fetch(`${apiV2Host}/admin/faxes/download/${id}`, {
          method: "GET",
          headers: {
            "Authorization": `Bearer ${this.$store.state.auth.accessToken}`
          }
        });

        const downloadRes = await downloadReq.json();
        const { raw, name } = downloadRes;

        this.tableLoading = false;
        if(raw){
          const link = document.createElement("a");
          link.href = raw;
          link.download = name;
          link.click();
        } else {
          this.$notify({
            title: 'Not Found',
            message: 'File Not Found.',
            type: 'warning'
          });
        }
      } catch (e) {
        console.log(e);
        this.tableLoading = false;
        this.$notify({
          title: 'Not Found',
          message: 'File Not Found.',
          type: 'warning'
        });
      }
    },

    async forceResendFax(faxId) {
      this.tableloading = true;

      try {
        const retryReq = await fetch(`${apiV2Host}/admin/faxes/retry/${faxId}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${this.$store.state.auth.accessToken}`
          }
        });

        const retryRes = await retryReq.json();
        const { status, message, error } = retryRes;
        const success = status === "success"

        //update the table data if retry queue was successful
        if(success){
          this.tableLoading = false;
          const findIndex = this.tableData.findIndex(item => item.id === faxId);
          if(findIndex >= 0){
            const data = {...this.tableData[findIndex]};
            data.status = "READY";
            data.error = "Retrying";
            this.tableData.splice(findIndex, 1, data);
          }
        }

        this.tableLoading = false;
        this.$notify({
          title: status,
          message: success ? message : error,
          type: status === "success" ? "success" : "error"
        });

      } catch (e){
        this.tableLoading = false;
        this.$notify({
          title: "Request failed",
          message: e,
          type: "error"
        });
      }
    }
  },

  created() {
    this.getFaxes();
  },

  filters: {
    number(value) {
      return !isNaN(value)
        ? new Intl.NumberFormat("en-US").format(value)
        : value;
    }
  }
};
</script>
